import './styles/index.css';
import React from 'react';
import { CartProvider } from './src/context/cart-context';
import CartDrawer from './src/components/cart-drawer';

export const wrapRootElement = ({ element }) => (
  <CartProvider>
    {element}
    <CartDrawer />
  </CartProvider>
);
